module.exports = __webpack_public_path__ + "68c2839e0ecc2c00774cd0271eb0f844.png";